/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_StylesInputs */

const en_quicktools_tab_styles = /** @type {(inputs: Quicktools_Tab_StylesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styles`)
};

const fr_quicktools_tab_styles = /** @type {(inputs: Quicktools_Tab_StylesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styles`)
};

const de_quicktools_tab_styles = /** @type {(inputs: Quicktools_Tab_StylesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile`)
};

const it_quicktools_tab_styles = /** @type {(inputs: Quicktools_Tab_StylesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stili`)
};

const ru_quicktools_tab_styles = /** @type {(inputs: Quicktools_Tab_StylesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стили`)
};

const es_quicktools_tab_styles = /** @type {(inputs: Quicktools_Tab_StylesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilos`)
};

const zh_cn2_quicktools_tab_styles = /** @type {(inputs: Quicktools_Tab_StylesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`款式`)
};

const ja_quicktools_tab_styles = /** @type {(inputs: Quicktools_Tab_StylesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイル`)
};

const hi_quicktools_tab_styles = /** @type {(inputs: Quicktools_Tab_StylesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैलियों`)
};

const pt_pt2_quicktools_tab_styles = /** @type {(inputs: Quicktools_Tab_StylesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilos`)
};

/**
* | output |
* | --- |
* | "Styles" |
*
* @param {Quicktools_Tab_StylesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_styles = /** @type {((inputs?: Quicktools_Tab_StylesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_StylesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_styles(inputs)
	if (locale === "de") return de_quicktools_tab_styles(inputs)
	if (locale === "it") return it_quicktools_tab_styles(inputs)
	if (locale === "ru") return ru_quicktools_tab_styles(inputs)
	if (locale === "es") return es_quicktools_tab_styles(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_styles(inputs)
	if (locale === "ja") return ja_quicktools_tab_styles(inputs)
	if (locale === "hi") return hi_quicktools_tab_styles(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_styles(inputs)
	return en_quicktools_tab_styles(inputs)
});